var _defs, _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:2.05px;}.cls-1,.cls-2{fill:none;stroke:#0089fb;stroke-miterlimit:10;}.cls-2{stroke-width:1.91px;}.cls-3{fill:#0089fb;fill-rule:evenodd;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.68,31.52c0-.23.09-.45.25-.61l1.84-1.84-1.84-1.84c-.34-.34-.34-.89,0-1.23.34-.34.89-.34,1.22,0l1.84,1.84,1.84-1.84c.22-.22.54-.3.84-.23.3.08.53.31.61.61.08.3,0,.62-.23.84l-1.84,1.84,1.84,1.84c.22.22.31.54.23.84-.08.3-.31.53-.61.61-.3.08-.62,0-.84-.23l-1.84-1.84-1.84,1.84c-.16.16-.38.25-.61.25s-.45-.09-.61-.25c-.16-.16-.25-.38-.25-.61h0s0,0,0,0h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.07,
    y: 16.48,
    width: 21.86,
    height: 4.47,
    rx: 1.17,
    ry: 1.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.03,36.83h-12.11c-.83,0-1.52-.59-1.57-1.35l-.89-14.17h17.05l-.93,14.17c-.05.75-.74,1.34-1.57,1.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.7bd7019c377af888865592fb066e2718.svg";
export { ForwardRef as ReactComponent };